var map = {
	"./Hugh_Davis.png": "5d51",
	"./Ron_Weiss.png": "55d9",
	"./刘乙齐.png": "e2ed",
	"./刘庆华.png": "ed1f",
	"./刘建.png": "3418",
	"./古槿.png": "b020",
	"./张学工.png": "9a5b",
	"./彭曙光.png": "1505",
	"./李梢.png": "ff69",
	"./汪小我.png": "fad0",
	"./蒋云.png": "ba99",
	"./谢震.png": "85de",
	"./赵海涛.png": "4dea",
	"./陆荫英.png": "c7dc",
	"./陈彬.png": "932a",
	"./黄慧雅.png": "ff6b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5f35";